import { Component, type ReactNode, type ErrorInfo } from 'react';
type Props = { children: ReactNode };
type State = { hasError: boolean; error: Error | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-card">
            <img
              src="/images/mascot/fox-peeking.png"
              alt=""
              style={{
                width: 110,
                height: 'auto',
                margin: '0 auto 8px',
                display: 'block',
                filter: 'drop-shadow(0 4px 12px rgba(14, 21, 48, 0.10))',
              }}
            />
            <h2>Something went wrong</h2>
            <p>
              Agent Loop hit a snag. Try refreshing, or head back to the
              dashboard.
            </p>
            <div className="error-boundary-actions">
              <button
                className="error-boundary-retry"
                onClick={this.handleReset}
              >
                Try again
              </button>
              <button
                className="error-boundary-home"
                onClick={() => {
                  this.handleReset();
                  window.location.href = '/dashboard';
                }}
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
